(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["auto-menu"] && !Shopify.designMode) return;
  try {
    class AutoMenu extends HTMLElement {
        constructor() {
            super();

            this.section = this.closest('.shopify-section');
            this.selector = this.dataset.identifier;

            this.items = this.section?.querySelectorAll(this.selector);

            this.accordionContent = this.querySelector('.accordion-content');

            if (this.items.length === 0) {
                console.error('No items found for the selector', this.selector);
                this.classList.add('hidden');
                return;
            }

            this.appendItems();
        }

        appendItems() {
            this.items.forEach((item, index) => {
                const autoMenuItem = document.createElement('div');

                let itemText = item.textContent.trim();

                if (itemText === '') {
                    //console.log('Item text is empty, skipping');
                    return;
                }

                let id = item.id;
                if (!id) {
                    id = 'section-' + (index + 1);
                    item.id = id;
                }

                autoMenuItem.classList = 'auto-menu-item text-lg cursor-pointer';
                autoMenuItem.dataset.id = id;
                autoMenuItem.textContent = itemText;
                this.querySelector('.auto-menu-items').appendChild(autoMenuItem);

                autoMenuItem.addEventListener('click', this.handleItemClick.bind(this));
            });

            this.accordionContent.classList.add('active');
        }

        handleItemClick(e) {
            e.preventDefault();

            const id = e.target.dataset.id,
                target = document.getElementById(id);

            target && target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    customElements.define('auto-menu', AutoMenu);
  } catch(e) { console.error(e); }
})();

})();
